import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const ConfirmBox = ({ open, onClose, options }) => {
  const defaultOptions = {
    title: 'Are you sure?',
    text: 'Do you want to proceed?',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonColor: 'primary',
    cancelButtonColor: 'secondary',
    showDenyButton: false,
    denyButtonColor: 'success',
    denyButtonText: 'Alt Action',
  };

  const mergedOptions = { ...defaultOptions, ...options };

  const handleConfirm = () => {
    onClose(true);
  };

  const handleCancel = () => {
    onClose(false);
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)}
      BackdropProps={{
        sx: { backgroundColor: 'transparent' },
      }}
      PaperProps={{
        sx: {
          boxShadow: 'auto',
        },
      }}
      sx={{left:{xs:'40px', sm:'0'}}}
    >
      <DialogTitle>{mergedOptions.title}</DialogTitle>
      <DialogContent>
        <Typography>{mergedOptions.text}</Typography>
      </DialogContent>
      <DialogActions sx={{display:'flex ',justifyContent: "flex-end",
        // justifyContent:{xs:'center', sm:'auto'},
          gap:{xs:'10px',sm:'auto'}}}>
        <Button
          variant="contained"
          color={mergedOptions.cancelButtonColor}
          onClick={handleCancel}
        >
          {mergedOptions.cancelButtonText}
        </Button>
        {mergedOptions.showDenyButton && (
          <Button
            variant="contained"
            color={mergedOptions.denyButtonColor}
            onClick={() => onClose({ isDenied: true })}
          >
            {mergedOptions.denyButtonText}
          </Button>
        )}

        <Button
          variant="contained"
          color={mergedOptions.confirmButtonColor}
          onClick={handleConfirm}
        >
          {mergedOptions.confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmBox;
